import classnames from 'classnames';
import { type ComponentProps, forwardRef, type PropsWithChildren } from 'react';
import type { Colors } from '../../types/colors';
import { Text } from '../text/text';
import styles from './chip.module.scss';

export type ChipProps = PropsWithChildren &
  Omit<ComponentProps<'span'>, 'ref'> & {
    backgroundColor?: Colors;
  };

export const Chip = forwardRef<HTMLSpanElement, ChipProps>(({ backgroundColor = 'Black', children, ...props }, ref) => (
  <span
    ref={ref}
    {...props}
    className={classnames(
      'chip',
      styles.chip,
      styles[`bg-${backgroundColor}`],
      Boolean(props.onClick) && styles.clickable,
      props.className,
    )}
  >
    <Text size="xs">{children}</Text>
  </span>
));
